<template>
  <div class="paramsInfo-set">
    <div class="sketchMap"></div>
    <div class="paramsInfo-part">
      <CardContainer class="setNet-part">
        <div class="setNet-SetTitle">
          {{ $t('Product.enableCW') }}
          <el-switch v-model="form.enable" style="margin-left: 16px"> </el-switch>
        </div>
      </CardContainer>
      <CardContainer class="setNet-part">
        <div class="setNet-SetTitle">
          {{ $t('Product.imgPart') }}
        </div>
        <el-row :gutter="20">
          <el-col :span="8" v-for="(config, i) in configs" :key="i">
            <div class="uploadPart">
              <Upload
                class="file__uploader upload-part"
                :img="config.iconId"
                :limit="1"
                accept="image/png,image/jpg,image/jpeg"
                @pickImg="pickImg(i, arguments)"
              >
              </Upload>
              <div class="upload-tips">
                {{ languageList.find((lang) => lang.value === config.language)['label'] }}
              </div>
            </div>
          </el-col>
        </el-row>
      </CardContainer>
      <CardContainer class="setNet-part">
        <div style="height: 548px">
          <div class="setNet-SetTitle">
            {{ $t('Product.stepPart') }}
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 24px;">
            <el-tab-pane
              :label="languageList.find((lang) => lang.value === item.language)['label']"
              :name="item.language"
              v-for="(item, index) in configs"
              :key="index"
            >
              <div style="height: 500px">
                <QuillEdit
                  :ref="'myQuillEditor' + item.language"
                  :content="item.content"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @change="onEditorChange($event)"
                >
                </QuillEdit>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </CardContainer>
    </div>
    <div class="bottomBt">
      <hl-button
        type="secondary"
        @click.native="save"
        :loading="saveLoading"
        :style="publishShow ? '' : 'margin-right:24px'"
      >
        {{ $t('Common.save') }}
      </hl-button>
      <hl-button
        @click.native="publish"
        v-if="publishShow"
        style="margin-right:24px"
        :loading="publishLoading"
      >
        {{ $t('Common.publish') }}
      </hl-button>
    </div>
  </div>
</template>

<script>
import Upload from '@/components/Upload'
import { uploadFile } from '@/utils/utils'
import { languageList } from '@/config/status'
import QuillEdit from '@/components/QuillEditor'
export default {
  name: 'index',
  props: {
    productKey: {
      type: String,
      default: ''
    }
  },
  components: {
    Upload,
    QuillEdit
  },
  data() {
    return {
      languageList,
      form: {
        enable: true,
        configs: []
      },
      PropertySelectList: [],
      configs: [],
      saveLoading: false,
      publishShow: true,
      publishLoading: false,
      activeName: languageList[0].value
    }
  },
  created() {
    // this.getTempInfoList()
  },
  mounted() {
    this.initData()
  },
  methods: {
    uploadFile,
    handleClick() {},
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    escapeStringHTML(str) {
      str = str.replace(/&lt;/g, '<')
      str = str.replace(/&gt;/g, '>')
      return str
    },
    async pickImg(i, argu) {
      let file = argu[0]
      if (file) {
        await uploadFile(file)
          .then((res) => {
            this.configs[i]['iconId'] = res.data
          })
          .catch(() => {})
      } else {
        this.configs[i]['iconId'] = ''
      }
    },
    cancel() {},
    //初始化赋值
    initData() {
      let configsList = []
      this.languageList.forEach((lang) => {
        configsList.push({
          language: lang.value,
          iconId: '',
          content: ''
        })
      })
      if (this.productKey) {
        const params = {
          productKey: this.productKey
        }
        this.$ajax.get(this.$api.product.iceProduct_setNetGuide_detail, params).then((res) => {
          if (res.data) {
            this.form = {
              enable: res.data.enable
            }
            this.configs = res.data.configs || configsList
            this.publishShow = res.data.update
          } else {
            this.form = {
              enable: true
            }
            this.configs = configsList
          }
          // this.form = {
          //   enable: res.data.enable || true
          // }
          // this.configs = res.data.configs || configsList
          // this.publishShow = res.data.update
        })
      } else {
        this.form = {
          enable: true
        }
        this.configs = configsList
      }
    },
    save() {
      // iceProduct_params_template_save
      // if (!this.checkForm()) return
      let newConfigs = JSON.parse(JSON.stringify(this.configs))
      let configs2 = newConfigs.map((item) => {
        let QuillName = 'myQuillEditor' + item.language
        item.content = this.$refs[QuillName][0]['detailContent']
        return item
      })
      this.saveLoading = true
      let params = {
        productKey: this.productKey,
        configs: configs2,
        enable: this.form.enable
      }
      let api = this.$api.product.iceProduct_setNetGuide_save
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      this.$ajax
        .post(api, params, config)
        .then((res) => {
          if (res.success) {
            this.$message.success(`${this.$t('Common.saveSuccess')}`)
            this.publishShow = true
          }

          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.saveLoading = false
        })
    },
    publish() {
      this.publishLoading = true
      let params = {
        productKey: this.productKey
      }
      let api = this.$api.product.iceProduct_setNetGuide_publish
      this.$ajax
        .get(api, params)
        .then((res) => {
          if (res.success) {
            this.$message.success(`${this.$t('Common.operationSuccess')}`)
            this.publishShow = false
          }
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.publishLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.paramsInfo-set {
  display: flex;
  .sketchMap {
    height: 720px;
    width: 330px;
    // border: 1px solid #333333;
    background-image: url('../../../../../assets/product_model_pic_distribution_network.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .paramsInfo-part {
    margin-left: 24px;
    flex: 1;
    .setNet-part {
      margin-top: 24px;
      .setNet-SetTitle {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 8px;
      }
      .uploadPart {
        //display: flex;
        //justify-content: center;
        //text-align: center;
        .upload-part {
          width: 100%;
          margin: 16px 24px 16px 0;
        }
        .upload-tips {
          width: 160px;
          text-align: center;
          margin-bottom: 8px;
          color: #999999;
        }
      }
    }
  }
}
.addBt {
  margin-top: 24px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  border: 2px dashed #dadfe6;
  text-align: center;
  line-height: 32px;
  color: #2046c7;
  cursor: pointer;
  &:hover {
    background: #eff4fc;
  }
  &:active {
    background: #e3e8f0;
  }
}
.bottomBt {
  background-color: #ffffff;
  left: -24px;
  right: -24px;
  position: fixed;
  bottom: 0;
  z-index: 6;
  height: 50px;
  width: calc(100vw + 240px);
  border-radius: 16px;
  text-align: right;
  padding-right: 214px;
  padding-top: 10px;
  box-shadow: 5px 0 25px 8px rgba(215, 222, 230, 0.4);
}
/deep/ .el-tabs .el-tabs__item {
  font-size: 16px;
  color: rgba(51, 51, 51, 0.65);
  &.is-active {
    color: #2046c7;
  }
}
</style>
